import { useCallback, useEffect, useRef, useState } from 'react';
import { addDropdownListener, getOpenDropdown, setOpenDropdown } from '../util/dropdownCoordinator';

export default function useCoordinatedDropdown() {
    const key = useRef({}).current;
    const currentOpen = useRef(false);
    const [open, setState] = useState(false);
    const setOpen = useCallback(value => {
        const next = typeof value === 'function' ? value(currentOpen.current) : value;
        currentOpen.current = next;
        if (next) setOpenDropdown(key);
        else if (getOpenDropdown() === key) setOpenDropdown(null);
        setState(next);
    }, [key]);
    useEffect(() => {
        const unsubscribe = addDropdownListener(active => {
            if (active !== key) { currentOpen.current = false; setState(false); }
        });
        return () => { unsubscribe(); if (getOpenDropdown() === key) setOpenDropdown(null); };
    }, [key]);
    return [open, setOpen];
}
